import { CONTRACT_TYPES } from "../../../webapp-commons/data";
import { fetchHil2 } from "../utils";
import { PROJECT_VALIDATION, PROJECTS_COLUMNS_NAMES } from "./DefaultSettings";

export function getTimelineTitles(item) {
  if (item.isAggregate) {
    const count = item.paramsGroup.length;
    switch (item.type) {
      case "BIEN_SOUMIS":
        return `${count} nouveaux biens ont été soumis`;
      case "BIEN_JUGE":
        return `${count} biens ont été jugés`;
      case "COMMENTAIRE_BIEN":
        return `${count} nouveaux commentaires sur des biens`;
      default:
        return "Inconnu";
    }
  } else {
    switch (item.type) {
      case "BIEN_SOUMIS":
        return "Un nouveau bien a été soumis";
      case "BIEN_JUGE":
        return "Un bien a été jugé";
      case "BIEN_VISITE":
        return "Une visite a été enregistrée";
      case "BIEN_VISITE_ANNULE":
        return "Une visite a été annulée";
      case "BIEN_CHOISI":
        return "Un bien final a été défini";
      case "COMMENTAIRE_BIEN":
        return "Commentaire sur un bien";
      case "COMMENTAIRE_PROJET":
        return "Commentaire sur un projet";
      case "NOMBRE_ANNONCES_VUES":
        return `Nous avons vu ${item.params.count} annonces`;
      case "CHANGEMENT_STATUT":
        return "Le statut du dossier a changé";
      case "SIGNATURE_BAIL":
        return "Signature du bail";
      case "FEEDBACK":
        return typeof item.params.sponsor === "boolean"
          ? "Avis donné"
          : "Demande d'avis ignorée";
      case "VISIT_ASSIST":
        return item.params
          ? "Demande d'accompagnement acceptée"
          : "Demande d'accompagnement refusée";
      default:
        return "Inconnu";
    }
  }
}

export function getTimelineLinks(item) {
  let i = 0;
  const getLink = item => {
    switch (item.type) {
      case "BIEN_SOUMIS":
      case "BIEN_JUGE":
      case "BIEN_VISITE":
      case "BIEN_VISITE_ANNULE":
      case "COMMENTAIRE_BIEN":
        return {
          href: `/host/${item.params.host}`,
          label: i === 0 ? "Voir le bien" : `Bien ${i}`
        };
      default:
        return null;
    }
  };
  if (item.isAggregate) {
    return item.paramsGroup.map(params => {
      ++i;
      return getLink({
        ...item,
        params
      });
    });
  } else {
    return [getLink(item)];
  }
}

export function getTimelineDescriptions(item) {
  switch (item.type) {
    case "BIEN_JUGE":
      if (item.isAggregate) {
        return null;
      } else {
        return `Le client ${
          item.params.value === "liked" ? "a aimé" : "n'a pas aimé"
        } le bien.`;
      }
    case "BIEN_VISITE_ANNULE": {
      const reason = item.params.reason;
      console.log("icii", reason);
      return `Annulé par ${
        reason === "hil"
          ? "Home In Love"
          : reason === "agency"
          ? "l'agence"
          : reason === "client"
          ? "le client"
          : "Inconnu"
      }`;
    }
    case "CHANGEMENT_STATUT":
      return `Il est désormais dans l'état : ${PROJECTS_COLUMNS_NAMES[
        item.params.currentProgress
      ] || "Inconnu"}`;
    case "SIGNATURE_BAIL":
      return `Date fixée au ${this.$options.filters.date(item.params.date)}`;
    default:
      return null;
  }
}
export function getShortInfoFields() {
  return {
    all: [
      {
        name: "lastName",
        label: "Nom",
        validation: PROJECT_VALIDATION["lastName"]
      },
      {
        name: "firstName",
        label: "Prénom",
        validation: PROJECT_VALIDATION["firstName"]
      },
      {
        name: "phoneNumber",
        label: "Téléphone",
        validation: PROJECT_VALIDATION["phoneNumber"]
      },
      {
        name: "email",
        label: "Mail",
        validation: "required"
      },
      {
        name: "company",
        label: "Entreprise",
        autocompleteUrl: "/prospects/_autocomplete?type=entreprise",
        linkValue: function() {
          return this.value.companyId
            ? `/prospect/${this.value.companyId}`
            : null;
        },
        cascade: async function(project, { autocomplete }) {
          if (autocomplete) {
            const completes = await fetchHil2("get", this.item.autocompleteUrl);
            const [company] = completes.filter(
              ({ name }) => project.company === name
            );
            if (!company) {
              this.value.companyId = null;
            } else {
              this.value.companyId = company._id;
              const prospect = await fetchHil2(
                "get",
                `/prospects/${company._id}`
              );
              this.value.companyContactName = prospect.companyContactName;
              this.value.companyPhone = prospect.companyContactPhone;
              this.value.companyMail = prospect.companyContactMail;
            }
          } else {
            this.value.companyId = null;
          }
        },
        validation: PROJECT_VALIDATION["company"]
      },
      {
        name: "actualCity",
        label: "Adresse de départ",
        as: "geocomplete",
        onAddressChanged: function(data) {
          this.value.fromAddressObject = data;
        },
        addressIsValidAtBeginning: () => false,
        validation: PROJECT_VALIDATION["actualCity"]
      },
      {
        name: "addressWork",
        label: "Adresse de travail",
        as: "geocomplete",
        onAddressChanged: function(data) {
          this.value.addressWorkObject = data;
        },
        addressIsValidAtBeginning: () => false,
        validation: PROJECT_VALIDATION["addressWork"]
      },
      {
        name: "sponsor",
        label: "D'où nous connaissez vous ? (Parrain)",
        validation: PROJECT_VALIDATION["sponsor"]
      }
    ]
  };
}

export function getInfoFields(validators = {}) {
  return {
    dossier: [
      {
        name: "addressWork",
        label: "Adresse de travail",
        as: "geocomplete",
        onAddressChanged: data => (this.project.addressWorkObject = data),
        addressIsValidAtBeginning: () => this.project.addressWorkObject != null,
        validation: validators["addressWork"]
      },
      {
        name: "moveWish",
        label: "Ville souhaitée",
        as: "geocomplete",
        onAddressChanged: (data, place) =>
          (this.project.moveWish = place.formatted_address),
        addressIsValidAtBeginning: () => this.project.moveWish != null,
        validation: validators["moveWish"]
      },
      {
        name: "contractualDistance",
        label: "Distance ancien → travail",
        readOnly: true,
        value: () =>
          this.project.addressWorkObject == null ||
          this.project.fromAddressObject == null
            ? "Adresse(s) précise(s) manquante(s)"
            : this.project.contractualDistance == null && this.distance == null
            ? "--"
            : `${Math.floor(
                (this.project.contractualDistance || this.distance) / 1000
              )}km`
      },
      {
        name: "contractualTime",
        label: "Temps ancien → travail",
        readOnly: true,
        value: () =>
          this.project.addressWorkObject == null ||
          this.project.fromAddressObject == null
            ? "Adresse(s) précise(s) manquante(s)"
            : this.project.contractualTime == null && this.time == null
            ? "--"
            : `${Math.floor(
                (this.project.contractualTime || this.time) / 60 / 60
              )}h ${Math.floor(
                (this.project.contractualTime || this.time) / 60
              ) % 60}mn`
      },
      {
        name: "mandateId",
        value: () => this.project.mandateId,
        readOnly: true,
        label: "Mandat",
        validation: validators["mandateId"]
      },
      {
        name: "leaseSignDate",
        label: "Signature du bail",
        as: "date",
        validation: validators["leaseSignDate"]
      }
    ],
    projectinfos: [
      {
        name: "typeOfEstate",
        label: "Type de bien",
        as: "select",
        items: [
          { text: "-- CHOISIR --", value: "", disabled: true },
          { text: "Appartement", value: "apartment" },
          { text: "Maison", value: "house" },
          { text: "Autre", value: "other" }
        ],
        validation: validators["typeOfEstate"]
      },
      {
        name: "surfacemin",
        label: "Surface minimum",
        suffix: "m²",
        validation: validators["surfacemin"]
      },
      {
        name: "numberOfRoom",
        label: "Nombre de pièces",
        validation: validators["numberOfRoom"]
      },
      {
        name: "budget",
        label: "Budget",
        suffix: "€",
        validation: validators["budget"]
      },
      {
        name: "dateMove",
        label: "Date d'emménagement",
        as: "date",
        validation: validators["dateMove"]
      },
      {
        name: "criterion1",
        label: "Critère 1",
        as: "select",
        items: ["Localisation", "Prix", "Superficie"],
        validation: validators["criterion1"]
      },
      {
        name: "criterion2",
        label: "Critère 2",
        as: "select",
        items: ["Localisation", "Prix", "Superficie"],
        validation: validators["criterion2"]
      },
      {
        name: "criterion3",
        label: "Critère 3",
        as: "select",
        items: ["Localisation", "Prix", "Superficie"],
        validation: validators["criterion3"]
      },
      {
        name: "zone",
        label: "Zone",
        as: "select",
        validation: validators["zone"],
        items: [
          { text: "A définir", value: "", disabled: true },
          { text: "Zone 1 (2200€)", value: 1 },
          { text: "Zone 2 (1900€)", value: 2 }
        ]
      }
    ]
  };
}

export function getTenantFields(validators = {}) {
  return {
    leclient: [
      {
        name: "lastName",
        label: "Nom",
        validation: validators["lastName"]
      },
      {
        name: "firstName",
        label: "Prénom",
        validation: validators["firstName"]
      },
      {
        name: "phoneNumber",
        label: "Téléphone",
        validation: validators["phoneNumber"]
      },
      {
        name: "userId",
        label: "Mail",
        readOnly: true,
        validation: validators["userId"]
      },
      {
        name: "actualCity",
        label: "Adresse de départ",
        as: "geocomplete",
        onAddressChanged: data => (this.project.fromAddressObject = data),
        addressIsValidAtBeginning: () => this.project.fromAddressObject != null,
        validation: validators["actualCity"]
      },
      {
        name: "civility",
        label: "Civilité",
        as: "select",
        items: ["", "Monsieur", "Madame"],
        validation: validators["civility"]
      },
      {
        name: "dateOfBirth",
        label: "Date de naissance",
        as: "date",
        validation: validators["dateOfBirth"]
      },
      {
        name: "placeOfBirth",
        label: "Lieu de naissance",
        as: "geocomplete",
        addressTypes: null,
        onAddressChanged: data => (this.project.placeOfBirthObject = data),
        addressIsValidAtBeginning: () =>
          this.project.placeOfBirthObject != null,
        validation: validators["placeOfBirth"]
      },
      {
        name: "deptOfBirth",
        label: "Dept/Pays de naissance",
        validation: validators["deptOfBirth"]
      },
      {
        name: "nationality",
        label: "Nationalité",
        validation: validators["nationality"]
      },
      {
        name: "familyStatus",
        label: "Situation familiale",
        as: "select",
        items: [
          "",
          "Marié(e) (communauté)",
          "Marié(e) (séparation de biens)",
          "Pacsé(e)",
          "Union libre",
          "Célibataire",
          "Divorcé(e)",
          "Veuf/ve"
        ],
        validation: validators["familyStatus"]
      },
      {
        name: "childrenCount",
        label: "Nombre d'enfants",
        as: "number",
        validation: validators["childrenCount"]
      },
      {
        name: "childrenAges",
        label: "Ages (séparés par ,)",
        validation: validators["childrenAges"]
      },
      {
        name: "childrenToBeBorn",
        label: "Enfants à naitre",
        as: "number",
        validation: validators["childrenToBeBorn"]
      },
      {
        name: "otherDependant",
        label: "Autres personnes à charge",
        validation: validators["otherDependant"]
      },
      {
        name: "wage",
        label: "Nouveau salaire net mensuel",
        as: "money",
        validation: validators["wage"]
      },
      {
        name: "referenceTaxRevenue",
        label: "Revenue fiscal de référence N-1",
        as: "money",
        validation: validators["referenceTaxRevenue"]
      },
      {
        name: "otherIncomes",
        label: "Autres revenus",
        as: "money",
        validation: validators["otherIncomes"]
      },
      {
        name: "previousOwnerType",
        label: "Statut habitation précédente",
        as: "select",
        items: ["Locataire", "Propriétaire", "Hébergé(e)"],
        validation: validators["previousOwnerType"]
      },
      {
        name: "sponsor",
        label: "D'où nous connaissez vous ? (Parrain)",
        validation: validators["sponsor"]
      }
    ],
    origin: [
      {
        name: "contractType",
        label: "Type de contrat",
        as: "select",
        items: CONTRACT_TYPES,
        validation: validators["contractType"]
      },
      {
        name: "job",
        label: "Poste",
        validation: validators["job"]
      },
      {
        name: "company",
        label: "Entreprise",
        autocompleteUrl: "/prospects/_autocomplete?type=entreprise",
        linkValue: () =>
          this.project.companyId ? `/prospect/${this.project.companyId}` : null,
        cascade: async function(project, { autocomplete }) {
          if (autocomplete) {
            const completes = await fetchHil2("get", this.item.autocompleteUrl);
            const [company] = completes.filter(
              ({ name }) => project.company === name
            );
            if (!company) {
              this.value.companyId = null;
            } else {
              this.value.companyId = company._id;
              const prospect = await fetchHil2(
                "get",
                `/prospects/${company._id}`
              );
              this.value.companyContactName = prospect.companyContactName;
              this.value.companyPhone = prospect.companyContactPhone;
              this.value.companyMail = prospect.companyContactMail;
            }
          } else {
            this.value.companyId = null;
          }
        },
        validation: validators["company"]
      },
      {
        name: "companySiret",
        label: "Siret de l'entreprise",
        validation: validators["companySiret"]
      },
      {
        name: "companyContactName",
        label: "Nom contact",
        validation: validators["companyContactName"]
      },
      {
        name: "companyPhone",
        label: "Tel contact",
        validation: validators["companyPhone"]
      },
      {
        name: "companyMail",
        label: "Mail contact",
        validation: validators["companyMail"]
      },
      {
        name: "contractStartDate",
        label: "Début de contrat",
        as: "date",
        validation: validators["contractStartDate"]
      },
      {
        name: "endOfTrialPeriod",
        label: "Fin de période d'essai",
        as: "date",
        validation: validators["endOfTrialPeriod"]
      },
      {
        name: "school",
        label: "Prescripteur",
        autocompleteUrl: "/prospects/_autocomplete?type=prescripteur",
        linkValue: () =>
          this.project.prescriberId
            ? `/prospect/${this.project.prescriberId}`
            : null,
        cascade: async function(project, { autocomplete }) {
          if (autocomplete) {
            const completes = await fetchHil2("get", this.item.autocompleteUrl);
            const [company] = completes.filter(
              ({ name }) => project.school === name
            );
            if (!company) {
              this.value.prescriberId = null;
            } else {
              this.value.prescriberId = company._id;
              const prospect = await fetchHil2(
                "get",
                `/prospects/${company._id}`
              );
              this.value.schoolName = prospect.companyContactName;
              this.value.schoolPhone = prospect.companyContactPhone;
              this.value.schoolMail = prospect.companyContactMail;
            }
          } else {
            this.value.companyId = null;
          }
        },
        validation: validators["school"]
      },
      {
        name: "schoolName",
        label: "Nom contact",
        validation: validators["schoolName"]
      },
      {
        name: "schoolPhone",
        label: "Tel contact",
        validation: validators["schoolPhone"]
      },
      {
        name: "schoolMail",
        label: "Mail contact",
        validation: validators["schoolMail"]
      }
    ],
    coClient: [
      {
        name: "coLastName",
        label: "Nom",
        validation: validators["coLastName"]
      },
      {
        name: "coFirstName",
        label: "Prénom",
        validation: validators["coFirstName"]
      },
      {
        name: "coPhoneNumber",
        label: "Téléphone",
        validation: validators["coPhoneNumber"]
      },
      {
        name: "coEmail",
        label: "Mail",
        validation: validators["coEmail"]
      },
      {
        name: "coAddress",
        label: "Adresse de départ",
        as: "geocomplete",
        onAddressChanged: data => (this.project.coAddressObject = data),
        addressIsValidAtBeginning: () => this.project.coAddressObject != null,
        validation: validators["coAddress"]
      },
      {
        name: "coCivility",
        label: "Civilité",
        as: "select",
        items: ["", "Monsieur", "Madame"],
        validation: validators["coCivility"]
      },
      {
        name: "coDateOfBirth",
        label: "Date de naissance",
        as: "date",
        validation: validators["coDateOfBirth"]
      },
      {
        name: "coPlaceOfBirth",
        label: "Lieu de naissance",
        as: "geocomplete",
        addressTypes: null,
        onAddressChanged: data => (this.project.coPlaceOfBirthObject = data),
        addressIsValidAtBeginning: () =>
          this.project.coPlaceOfBirthObject != null,
        validation: validators["coPlaceOfBirth"]
      },
      {
        name: "coDeptOfBirth",
        label: "Dept/Pays de naissance",
        validation: validators["coDeptOfBirth"]
      },
      {
        name: "coNationality",
        label: "Nationalité"
      },
      {
        name: "coFamilyStatus",
        label: "Situation familiale",
        as: "select",
        items: [
          "",
          "Marié(e) (communauté)",
          "Marié(e) (séparation de biens)",
          "Pacsé(e)",
          "Union libre",
          "Célibataire",
          "Divorcé(e)",
          "Veuf/ve"
        ]
      },
      {
        name: "coChildrenCount",
        label: "Nombre d'enfants",
        as: "number"
      },
      {
        name: "coChildrenAges",
        label: "Ages (séparés par ,)"
      },
      {
        name: "coChildrenToBeBorn",
        label: "Enfants à naitre",
        as: "number"
      },
      {
        name: "coOtherDependant",
        label: "Autres personnes à charge"
      },
      {
        name: "coWage",
        label: "Nouveau salaire net mensuel",
        as: "money"
      },
      {
        name: "coReferenceTaxRevenue",
        label: "Revenue fiscal de référence N-1",
        as: "money"
      },
      {
        name: "coOtherIncomes",
        label: "Autres revenus",
        as: "money"
      }
    ],
    coOrigin: [
      {
        name: "coContractType",
        label: "Type de contrat",
        as: "select",
        items: CONTRACT_TYPES
      },
      { name: "coCompany", label: "Entreprise" },
      {
        name: "coWorkAddress",
        label: "Adresse de travail",
        validation: "",
        as: "geocomplete",
        onAddressChanged: data => (this.project.coWorkAddressObject = data),
        addressIsValidAtBeginning: () =>
          this.project.coWorkAddressObject != null
      },
      {
        name: "coJob",
        label: "Poste"
      },
      {
        name: "coContractStartDate",
        label: "Début de contrat",
        as: "date"
      },
      {
        name: "coEndOfTrialPeriod",
        label: "Fin de période d'essai",
        as: "date"
      }
    ],
    g1Client: [
      { name: "g1LastName", label: "Nom" },
      { name: "g1FirstName", label: "Prénom" },
      {
        name: "g1PhoneNumber",
        label: "Téléphone"
      },
      { name: "g1Email", label: "Mail" },
      {
        name: "g1Address",
        label: "Adresse",
        as: "geocomplete",
        onAddressChanged: data => (this.project.g1AddressObject = data),
        addressIsValidAtBeginning: () => this.project.g1AddressObject != null
      },
      {
        name: "g1Civility",
        label: "Civilité",
        as: "select",
        items: ["", "Monsieur", "Madame"]
      },
      {
        name: "g1DateOfBirth",
        label: "Date de naissance",
        as: "date"
      },
      {
        name: "g1PlaceOfBirth",
        label: "Lieu de naissance",
        as: "geocomplete",
        addressTypes: null,
        onAddressChanged: data => (this.project.g1PlaceOfBirthObject = data),
        addressIsValidAtBeginning: () =>
          this.project.g1PlaceOfBirthObject != null
      },
      {
        name: "g1Nationality",
        label: "Nationalité"
      },
      {
        name: "g1FamilyStatus",
        label: "Situation familiale",
        as: "select",
        items: [
          "",
          "Marié(e) (communauté)",
          "Marié(e) (séparation de biens)",
          "Pacsé(e)",
          "Union libre",
          "Célibataire",
          "Divorcé(e)",
          "Veuf/ve"
        ]
      },
      {
        name: "g1ChildrenCount",
        label: "Nombre d'enfants",
        as: "number"
      },
      {
        name: "g1Wage",
        label: "Nouveau salaire net mensuel",
        as: "money"
      },
      {
        name: "g1ReferenceTaxRevenue",
        label: "Revenue fiscal de référence N-1",
        as: "money"
      },
      {
        name: "g1OtherIncomes",
        label: "Autres revenus",
        as: "money"
      },
      {
        name: "g1Comment",
        label: "Commentaire"
      }
    ],
    g1Origin: [
      {
        name: "g1ContractType",
        label: "Type de contrat",
        as: "select",
        items: CONTRACT_TYPES
      },
      { name: "g1Company", label: "Entreprise" },
      {
        name: "g1WorkAddress",
        label: "Adresse de travail",
        validation: "",
        as: "geocomplete",
        onAddressChanged: data => (this.project.g1WorkAddressObject = data),
        addressIsValidAtBeginning: () =>
          this.project.g1WorkAddressObject != null
      },
      {
        name: "g1Job",
        label: "Poste"
      },
      {
        name: "g1ContractStartDate",
        label: "Début de contrat",
        as: "date"
      },
      {
        name: "g1EndOfTrialPeriod",
        label: "Fin de période d'essai",
        as: "date"
      }
    ],
    g2Client: [
      { name: "g2LastName", label: "Nom" },
      { name: "g2FirstName", label: "Prénom" },
      {
        name: "g2PhoneNumber",
        label: "Téléphone"
      },
      { name: "g2Email", label: "Mail" },
      {
        name: "g2Address",
        label: "Adresse",
        as: "geocomplete",
        onAddressChanged: data => (this.project.g2AddressObject = data),
        addressIsValidAtBeginning: () => this.project.g2AddressObject != null
      },
      {
        name: "g2Civility",
        label: "Civilité",
        as: "select",
        items: ["", "Monsieur", "Madame"]
      },
      {
        name: "g2DateOfBirth",
        label: "Date de naissance",
        as: "date"
      },
      {
        name: "g2PlaceOfBirth",
        addressTypes: null,
        label: "Lieu de naissance",
        as: "geocomplete",
        onAddressChanged: data => (this.project.g2PlaceOfBirthObject = data),
        addressIsValidAtBeginning: () =>
          this.project.g2PlaceOfBirthObject != null
      },
      {
        name: "g2Nationality",
        label: "Nationalité"
      },
      {
        name: "g2FamilyStatus",
        label: "Situation familiale",
        as: "select",
        items: [
          "",
          "Marié(e) (communauté)",
          "Marié(e) (séparation de biens)",
          "Pacsé(e)",
          "Union libre",
          "Célibataire",
          "Divorcé(e)",
          "Veuf/ve"
        ]
      },
      {
        name: "g2ChildrenCount",
        label: "Nombre d'enfants",
        as: "number"
      },
      {
        name: "g2Wage",
        label: "Nouveau salaire net mensuel",
        as: "money"
      },
      {
        name: "g2ReferenceTaxRevenue",
        label: "Revenue fiscal de référence N-1",
        as: "money"
      },
      {
        name: "g2OtherIncomes",
        label: "Autres revenus",
        as: "money"
      },
      {
        name: "g2Comment",
        label: "Commentaire"
      }
    ],
    g2Origin: [
      {
        name: "g2ContractType",
        label: "Type de contrat",
        as: "select",
        items: CONTRACT_TYPES
      },
      { name: "g2Company", label: "Entreprise" },
      {
        name: "g2WorkAddress",
        label: "Adresse de travail",
        validation: "",
        as: "geocomplete",
        onAddressChanged: data => (this.project.g2WorkAddressObject = data),
        addressIsValidAtBeginning: () =>
          this.project.g2WorkAddressObject != null
      },
      {
        name: "g2Job",
        label: "Poste"
      },
      {
        name: "g2ContractStartDate",
        label: "Début de contrat",
        as: "date"
      },
      {
        name: "g2EndOfTrialPeriod",
        label: "Fin de période d'essai",
        as: "date"
      }
    ]
  };
}

export function roleToHumanReadable(role) {
  switch (role) {
    case "lead":
      return "Lead";
    case "sale":
      return "Commercial";
    case "dispatcher":
      return "Répartiteur";
    case "reloc":
      return "Relocation";
    case "alsender":
      return "Dossier final";
    default:
      return "";
  }
}
